module.exports = __webpack_public_path__ + "static/media/team-1.c8993c80.png";